import { api } from './api/endpoints.js';
import { setToken } from './api/client.js';
import { enterFullscreen } from './tg.js';

const TOKEN_KEY = 'hb_token';

// Returns { user, isNew }. Uses Telegram WebApp.initData if available,
// else falls back to /v1/auth/dev (gated by BE ENABLE_MOCK_TOPUP) using VITE_DEV_* env.
export async function login() {
  const cached = sessionStorage.getItem(TOKEN_KEY);
  if (cached) {
    setToken(cached);
    try {
      const me = await api.getMe();
      return { user: me, isNew: false };
    } catch {
      sessionStorage.removeItem(TOKEN_KEY);
    }
  }

  const tg = window.Telegram?.WebApp;
  if (tg && tg.initData && tg.initData.length > 0) {
    enterFullscreen();
    const resp = await api.authTelegram(tg.initData);
    setToken(resp.token);
    sessionStorage.setItem(TOKEN_KEY, resp.token);
    return { user: resp.user, isNew: resp.user?.is_new ?? false };
  }

  // Dev fallback — local browser without Telegram.
  const devId = Number(import.meta.env.VITE_DEV_TELEGRAM_ID || 999000111);
  const devUsername = import.meta.env.VITE_DEV_USERNAME || 'local_dev';
  const devName = import.meta.env.VITE_DEV_NAME || 'Local Dev';
  const resp = await api.authDev(devId, devUsername, devName);
  setToken(resp.token);
  sessionStorage.setItem(TOKEN_KEY, resp.token);
  return { user: resp.user, isNew: resp.user?.is_new ?? false };
}

export function logout() {
  sessionStorage.removeItem(TOKEN_KEY);
  setToken(null);
}
